import { useCallback, useState } from "react";
import type { ChangeEvent } from "react";

import toast from "react-hot-toast";

import { Button, Divider, Form } from "simplydo/react/ui";
import { Input } from "simplydo/react/ui";

import actions from "actions";
import api from "api";
import { useAppDispatch, useAppSelector } from "store";

import SettingActions from "../SettingActions";

const InitialProfileSetup = () => {
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();

  const [saving, setSaving] = useState(false);
  const [firstName, setFirstName] = useState(user?.profile?.firstName);
  const [lastName, setLastName] = useState(user?.profile?.lastName);

  const saveProfile = useCallback(() => {
    if (!user) return;
    setSaving(true);
    const profile = {
      ...user.profile,
      firstName: firstName ?? "",
      lastName: lastName ?? "",
    };
    api.users.update(
      user._id,
      { profile },
      (newUser) => {
        setSaving(false);
        dispatch(
          actions.user.receiveUser({ ...user, profile: newUser.profile }),
        );
      },
      (err) => {
        toast.error(err.message);
        setSaving(false);
      },
    );
  }, [firstName, lastName, user, dispatch]);

  return (
    <>
      <h3>You are about to join {user?.ownerOrganisation?.name}!</h3>
      <p>
        We just need to know a few more details about you. To continue, please
        let others know who you are.
      </p>
      <Form>
        <Form.Group widths="equal">
          <Form.Field
            control={Input}
            fluid
            label="First name"
            placeholder="First name"
            value={firstName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setFirstName(e.target.value)
            }
            autoComplete="given-name"
          />
          <Form.Field
            control={Input}
            fluid
            label="Last name"
            placeholder="Last name"
            value={lastName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setLastName(e.target.value)
            }
            autoComplete="family-name"
          />
        </Form.Group>
        <Divider hidden />
        <SettingActions>
          <Button
            onClick={saveProfile}
            loading={saving}
            disabled={!firstName || !lastName}
            primary
            content="Save profile"
          />
        </SettingActions>
      </Form>
    </>
  );
};

export default InitialProfileSetup;
